<template>
  <div id="app">
    <p id="header"><v-icon large color="black">{{projectPrivacyIcon}}</v-icon>{{projectPrivacy}} Project - <i>{{$store.state.currentProjectName}}</i></p>
    <!-- Buttons -->
    <v-layout row wrap>
      <v-flex xs6 sm6>
        <div class="text-xs-left">
          <v-tooltip top>
            <v-btn slot="activator" color="light-blue darken-4" fab small dark @click="executeWorkflow()">
              <v-icon color="white">play_arrow</v-icon>
            </v-btn>
            <span>Execute Workflow</span>
          </v-tooltip>
        </div>
      </v-flex>
      <v-flex xs6 sm6>
        <div class="text-xs-right">
          <v-tooltip top>
            <v-btn v-if="canSave" slot="activator" color="success" fab small dark @click="saveWorkflow()">
              <v-icon color="black">{{projectSaveIcon}}</v-icon>
            </v-btn>
            <v-btn v-else-if="canDuplicate" slot="activator" color="success" fab small dark @click="duplicateThisProject()">
              <v-icon color="black">{{projectSaveIcon}}</v-icon>
            </v-btn>
            <v-btn v-else slot="activator" color="light grey" fab small dark :ripple=false depressed @click="cannotSaveProjectMessage()">
              <v-icon color="black">save</v-icon>
            </v-btn>
            <span>{{projectSaveText}}</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn slot="activator" color="primary" fab small dark @click="showModals['project-version-selection']=true">
              <v-icon color="black">folder_open</v-icon>
            </v-btn>
            <span>Project Version Selection</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn slot="activator" color="warning" fab small dark @click="showModals['import-data-file']=true">
              <v-icon color="black">insert_drive_file</v-icon>
            </v-btn>
            <span>Import Data File</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn slot="activator" color="light-blue" fab small dark @click="showModals['method-selection']=true">
              <v-icon color="black">library_books</v-icon>
            </v-btn>
            <span>Method Selection</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn slot="activator" color="error" fab small dark @click="deleteWorkflow()">
              <v-icon color="black">delete</v-icon>
            </v-btn>
            <span>Delete Workflow</span>
          </v-tooltip>
          <v-menu offset-y>
            <v-tooltip slot="activator" top>
              <v-btn slot="activator" color="info" fab small dark>
                <v-icon color="black">menu</v-icon>
              </v-btn>
              <span>Project Menu</span>
            </v-tooltip>
            <v-list>
              <v-list-tile @click="showModals['import-workflow']=true">
                <v-list-tile-title>Import Workflow</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="exportWorkflow()">
                <v-list-tile-title>Export Workflow</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </v-flex>
      <!--**************-->
    </v-layout>
    <!-- Button modals -->
    <project-version-selection-modal v-bind:showModal="showModals['project-version-selection']" :versions="versionArray" v-on:select-version="importWorkflow" v-on:hide-modal="showModals['project-version-selection']=false"></project-version-selection-modal>
    <method-selection-modal v-bind:showModal="showModals['method-selection']" v-on:add-method="generateModule" v-on:hide-modal="showModals['method-selection']=false"></method-selection-modal>
    <import-data-file-modal v-bind:showModal="showModals['import-data-file']" v-on:add-data="generateModule" v-on:hide-modal="showModals['import-data-file']=false"></import-data-file-modal>
    <import-workflow-modal v-bind:showModal="showModals['import-workflow']" v-on:import-workflow="importWorkflow" v-on:hide-modal="showModals['import-workflow']=false"></import-workflow-modal>
    <edit-description-modal v-bind:showModal="showModals['edit-description']" :mod="editingModuleDescription" v-on:hide-modal="editDescription"></edit-description-modal>
    <div id='modules' ref='modules'><!-- Modules are mounted here --></div>
    <div id='modals' ref='modals'><!-- Modals are mounted here --></div>
  </div>
</template>

<script>
import Vue from 'vue'
import {EventBus} from '@/event-bus.js'
import jsplumb,{ jsPlumb, jsPlumbUtil } from 'jsplumb'
import JSZip from 'jszip'
import Papa from 'PapaParse'
import saveAs from 'file-saver';

import ProjectVersionSelectionModal from '@/components/Workspace/Menus/ProjectVersionSelectionModal'
import MethodSelectionModal from '@/components/Workspace/Menus/MethodSelectionModal'
import ImportDataFileModal from '@/components/Workspace/Menus/ImportDataFileModal'
import ImportWorkflowModal from '@/components/Workspace/Menus/ImportWorkflowModal'
import EditDescriptionModal from '@/components/Workspace/Menus/EditDescriptionModal'

import DataModule from '@/components/Workspace/Methods/DataModule'
import SortModule from '@/components/Workspace/Methods/SortModule'
import OrderByModule from '@/components/Workspace/Methods/OrderByModule'
import CATSDModule from '@/components/Workspace/Methods/CATSDModule'
import DCMSRFModule from '@/components/Workspace/Methods/DCMSRFModule'
import ELECTRETRINCModule from '@/components/Workspace/Methods/ELECTRETRINCModule'
import AdditiveAggregationModule from '@/components/Workspace/Methods/AdditiveAggregationModule'

import DataModal from '@/components/Workspace/Methods/DataModal'
import SortModal from '@/components/Workspace/Methods/SortModal'
import OrderByModal from '@/components/Workspace/Methods/OrderByModal'
import CATSDModal from '@/components/Workspace/Methods/CATSDModal'
import DCMSRFModal from '@/components/Workspace/Methods/DCMSRFModal'
import ELECTRETRINCModal from '@/components/Workspace/Methods/ELECTRETRINCModal'
import AdditiveAggregationModal from '@/components/Workspace/Methods/AdditiveAggregationModal'

import SortService from '@/services/SortService'
import OrderByService from '@/services/OrderByService'
import CATSDService from '@/services/CATSDService'
import DCMSRFService from '@/services/DCMSRFService'
import ELECTRETRINCService from '@/services/ELECTRETRINCService'
import AdditiveAggregationService from '@/services/AdditiveAggregationService'

const findCycle = require('find-cycle/directed')

export default {
  components: {
    ProjectVersionSelectionModal,
    MethodSelectionModal,
    ImportDataFileModal,
    ImportWorkflowModal,
    EditDescriptionModal
  },
  data: () => ({
    showModals: {
      'project-version-selection': false,
      'method-selection': false,
      'import-data-file': false,
      'import-workflow': false,
      'edit-description': false
    },
    allModules: [],
    moduleData: {},
    moduleComponents: {
      'data': {module: DataModule, modal: DataModal},
      'sort': {module: SortModule, modal: SortModal},
      'orderby': {module: OrderByModule, modal: OrderByModal},
      'catsd': {module: CATSDModule, modal: CATSDModal},
      'dcmsrf': {module: DCMSRFModule, modal: DCMSRFModal},
      'electre': {module: ELECTRETRINCModule, modal: ELECTRETRINCModal},
      'addagg': {module: AdditiveAggregationModule, modal: AdditiveAggregationModal}
    },
    methodServices: {
      'sort': SortService,
      'orderby': OrderByService,
      'catsd': CATSDService,
      'dcmsrf': DCMSRFService,
      'electre': ELECTRETRINCService,
      'addagg': AdditiveAggregationService
    },
    canSave: false,
    canDuplicate: false,
    projectPrivacy: '',
    projectPrivacyIcon: '',
    projectSaveIcon: '',
    projectSaveText: '',
    versionArray: [],
    editingModuleDescription: null
  }),
  methods: {
    initializeWorkspace() {
      var ownerEmail = this.$store.state.email;
      var projectId = this.$store.state.currentProjectId;
      if(projectId) {
        EventBus.$emit('start-loading');
        this.$http.get(this.$store.state.serverHttpUrl+'/project?_id='+projectId+'&ownerEmail='+ownerEmail).then(
          function (response) {
            this.versionArray = response.data.saveFile;
            if(this.versionArray.length > 0) {
              for (var i=0; i < this.versionArray.length; i++) {
                this.versionArray[i] = JSON.parse(this.versionArray[i]);
              }
              this.importWorkflow(this.versionArray[this.versionArray.length - 1]);
            }
            if(response.data.privacy=='Public'){
              this.projectPrivacy = 'Public';
              this.projectPrivacyIcon = 'folder_shared';
            }
            else if(response.data.privacy=='Private'){
              this.projectPrivacy = 'Private';
              this.projectPrivacyIcon = 'folder';
            }
            if(ownerEmail){
              this.canDuplicate = true;
              if(response.data.ownerEmail===ownerEmail){
                this.canSave = true;
                this.projectSaveIcon = 'save';
                this.projectSaveText = 'Save Project';
              }
              else{
                this.cannotSaveProjectMessage();
                this.projectSaveIcon = 'file_copy';
                this.projectSaveText = 'Duplicate Project';
              }
            }
            else this.projectSaveText = 'Not able to Save';
            EventBus.$emit('stop-loading');
          }, function (err) {
            EventBus.$emit('stop-loading');
            EventBus.$emit('send-notification', {text: 'Error loading project'});
        });
      } else { // anonymous workspace
        this.$store.dispatch('setCurrentProjectName', 'Anonymous');
        this.projectSaveText = 'Not able to Save';
        this.cannotSaveProjectMessage();
      }
    },
    cannotSaveProjectMessage() {
      if(this.canDuplicate){
        var msg = 'You cannot save this project. You can only duplicate or export it.';
      }
      else{
        var msg = 'You cannot save this project. You can only export it.';
      }
      EventBus.$emit('send-notification', {text: msg, color: 'info'});
    },
    duplicateThisProject(item) {
      var ownerEmail = this.$store.state.email;
      var user = this.$store.state.user;
      var projectId = this.$store.state.currentProjectId;
      var data = this.buildWorkflowJson();
      this.versionArray.push(data);
      const exportData = JSON.stringify(data);
      this.$http.get(this.$store.state.serverHttpUrl+'/project?_id='+projectId+'&ownerEmail='+ownerEmail).then(
        function (response) {
          this.$http.post(this.$store.state.serverHttpUrl+'/project', {
            name: response.data.name + ' (copy)',
            ownerEmail: ownerEmail,
            ownerUsername: user,
            privacy: response.data.privacy,
            saveFile: exportData
          }).then(function (response) {
            EventBus.$emit('send-notification', {text: 'Project duplicated successfully to My Projects', color: 'success'});
          }, function (err) {
            EventBus.$emit('send-notification', {text: 'Error duplicating project ('+err+')'});
          })
        }, function (err) {
          EventBus.$emit('send-notification', {text: 'Error loading project to duplicate'});
      });
    },
    clone(object) {
      return JSON.parse(JSON.stringify(object))
    },
    moveModule(id, x, y) {
      var d = document.getElementById(id);
      d.style.position = "absolute";
      d.style.left = x + 'px';
      d.style.top = y + 'px';
    },
    resetModulePosition(id) {
      this.moveModule(id, 0, 0);
    },
    getModulePosition(id) {
      var d = document.getElementById(id);
      return [d.style.left, d.style.top];
    },
    generateModuleID(modType) {
      const matches = this.allModules.filter(s => s.includes(modType));
      if(matches.length > 0) {
        var n = 1;
        var id = modType + n;
        while(matches.includes(id)) {
          n += 1;
          id = modType + n;
        }
        return id;
      }
      else 
        return modType + 1;
    },
    generateModule(modType, modData, bypassId) {
      var id = bypassId ? bypassId : this.generateModuleID(modType);
      var name = modData.name ? modData.name : id.replace(modType, modData.name.replace(/[0-9]/g, ''));
      // update arrays with module id and data
      this.allModules.push(id);
      if(!(id in this.moduleData)) this.moduleData[id] = modData;
      this.moduleData[id].id = id;
      this.moduleData[id].name = name;
      // mount module component
      var ModuleClass = Vue.extend(this.moduleComponents[modType].module);
      var moduleInstance = new ModuleClass({
        propsData: {
          id: id,
          name: name
        }
      });
      moduleInstance.$mount();
      this.$refs.modules.appendChild(moduleInstance.$el);
      this.resetModulePosition(id);
      // mount modal component
      var ModalClass = Vue.extend(this.moduleComponents[modType].modal);
      var modalInstance = new ModalClass({
        propsData: {
          id: id,
          name: name,
          output: modData.output // is an object containing: {data, headers, description}
        } 
      });
      modalInstance.$mount();
      this.$refs.modals.appendChild(modalInstance.$el);
      // make module draggable and endpoints interactable
      jsPlumb.draggable(id, {containment: true});
      // meanwhile the endpoint ids have been sent from the modal component as an event
      for(var endpoint of this.moduleData[id].endpoints)
        endpoint.isSource ? jsPlumb.makeSource(endpoint.id) : jsPlumb.makeTarget(endpoint.id);
      return id;
    },
    selectVersion(item) {

    },
    executeModule(id) {
      if(this.moduleData[id]!=null) {
        // run the respective method service
        var methodType = this.moduleData[id].type;
        var methodInput = this.moduleData[id].input;
        var output = this.methodServices[methodType].execute(methodInput);
        if(!output.err) {
          this.moduleData[id].output.data = output;
          var connections = jsPlumb.getConnections();
          var found = connections.find(function(element) {
            return element.sourceId === id+'-output';
          });
          if(found) {
            this.moduleData[id].output.data = output;
            var updateObj = {property: null, value: this.moduleData[id].output.data, headers: this.moduleData[id].output.headers};
            EventBus.$emit('update-module-'+found.targetId.replace('-input', ''), updateObj);
          } else {
            var newModData = {
              name: this.moduleData[id].name + ' Output',
              type: 'data',
              output: {
                data: output,
                headers: this.moduleData[id].output.headers,
                description: this.moduleData[id].output.description
              }
            };
            var outputModId = this.generateModule('data', newModData);
            var sourcePos = this.getModulePosition(id);
            var x = parseInt(sourcePos[0].slice(0, -2))+220;
            var y = parseInt(sourcePos[1].slice(0, -2));
            this.moveModule(outputModId, x, y);
            jsPlumb.connect({source: id+'-output', target: outputModId+'-input'});
          }
        } else
          EventBus.$emit('send-notification', {text: 'Error executing module '+this.moduleData[id].name + ' (' + output.msg + ')'});
      } else
        EventBus.$emit('send-notification', {text: 'Error executing module'});
    },
    executeWorkflow() {
      EventBus.$emit('start-loading');
      // init object with info about execution order
      var executionData = {};
      this.allModules.forEach(mod => {
        executionData[mod] = {executed: false, precedents: []};
      });
      // find out what the precedents are
      var connections = jsPlumb.getConnections();
      connections.forEach(conn => {
        var sourceModuleId = conn.sourceId.replace('-output', '');
        var targetModuleId = conn.targetId.substr(0, conn.targetId.indexOf('-'));
        executionData[targetModuleId].precedents.push(sourceModuleId);
      });
      // detect infinite cycles in the graph
      const getConnectedNodes = node => executionData[node].precedents;
      const cycles = findCycle(Object.keys(executionData), getConnectedNodes);
      if(cycles) {
        EventBus.$emit('stop-loading');
        EventBus.$emit('send-notification', {text: 'Error executing workflow (loops detected)'});
        return;
      }
      // execute everything, taking into account the precedents
      var toExecute = this.allModules.length;
      var executed = 0;
      while(executed < toExecute)
        for(var mod of Object.keys(executionData)) {
          if(!executionData[mod].executed) {
            // can execute if all precedents already executed
            var canExecute = true;
            for(var prec of executionData[mod].precedents)
              canExecute = canExecute && executionData[prec].executed;
            if(canExecute) {
              // update module with precedents output data, to use as input
              for(var endpoint of this.moduleData[mod].endpoints) {
                var found = connections.find(function(element) {
                  return element.targetId === endpoint.id;
                });
                if(found) {
                  var sourceModuleId = found.sourceId.replace('-output', '');
                  if(this.moduleData[sourceModuleId].type!=='data' && this.moduleData[mod].type!=='data') {
                    var property = endpoint.id.split('-')[1];
                    if(this.moduleData[mod].type !== 'data')
                      this.moduleData[mod].input[property] = this.moduleData[sourceModuleId].output.data;
                    else
                      this.moduleData[mod].output.data = this.moduleData[sourceModuleId].output.data;
                    var updateObj = {property: property, value: this.moduleData[sourceModuleId].output.data};
                    EventBus.$emit('update-module-'+mod, updateObj);
                  }
                }
              }
              if(this.moduleData[mod].type!=='data')
                this.executeModule(mod)
              executionData[mod].executed = true;
              executed+=1;
            }
          }
        }
      EventBus.$emit('stop-loading');
    },
    duplicateModule(mod) {
      var modData = this.clone(this.moduleData[mod]);
      var copyNumber = 1;
      var modNames = Object.keys(this.moduleData).map(key => this.moduleData[key].name);
      if(modData.type==='data') {
        while(modNames.includes(modData.name+'('+copyNumber+')'))
        copyNumber++;
      modData.name += '(' + copyNumber + ')';
      }
      var newModId = this.generateModule(modData.type, modData);
      // update modal input data
      var modData = this.clone(this.moduleData[mod]);
      for(var prop in modData.input) {
        if(modData.input[prop]!==null && !jsPlumb.getAllConnections().map(c => c.targetId).includes(newModId+'-'+prop)) {
          var updateObj = {property: prop, value: modData.input[prop]};
          EventBus.$emit('update-module-'+newModId, updateObj);
        }
      }
    },
    deleteModule(mod) {
      var allConnections = jsPlumb.getAllConnections();
      for(var endpoint of this.moduleData[mod].endpoints) {
        jsPlumb.select().each((conn) => {
          if(conn.sourceId === endpoint.id || conn.targetId === endpoint.id) 
            this.deleteConnection(conn)
        });
        if(jsPlumb.isSource(endpoint.id) || jsPlumb.isTarget(endpoint.id)) jsPlumb.remove(endpoint.id);
      }
      delete this.moduleData[mod];
      EventBus.$emit('destroy-modal-'+mod);
      EventBus.$emit('destroy-module-'+mod);
      var index = this.allModules.indexOf(mod);
      if(index > -1) this.allModules.splice(index, 1);
      else {
        console.log('error deleting module '+mod);
        return;
      }
    },
    deleteAllModules() { 
      while(this.allModules.length>0)
        this.deleteModule(this.allModules[0]);
      jsPlumb.deleteEveryEndpoint();
    },
    deleteWorkflow() {
      this.$swal({
        titleText: "Delete all modules and connections of the current workflow?",
        type: 'warning',
        showCancelButton: true,
        allowEnterKey: false,
        confirmButtonColor: '#FF5252',
        cancelButtonColor: '#33b5e5',
        confirmButtonText: 'Delete',
        customClass: 'elevation-5'
      }).then((result) => {
        if(result.value) {
          this.deleteAllModules();
          EventBus.$emit('send-notification', {text: 'Workflow deleted successfully', color: 'success'});
        }
      });
    },
    newConnection(info) {
      var sourceModuleId = info.sourceId.replace('-output', '');
      var targetModuleId = info.targetId.substr(0, info.targetId.indexOf('-'));
      var property = info.targetId.split('-')[1];
      if(this.moduleData[sourceModuleId].output.data !== undefined) {
        var updateObj = {property: property, value: this.moduleData[sourceModuleId].output.data, newConnection: true, headers: this.moduleData[sourceModuleId].output.headers};
        EventBus.$emit('update-module-'+targetModuleId, updateObj);
      }
      if(this.moduleData[targetModuleId].type !== 'data')
        this.moduleData[sourceModuleId].output.data = this.moduleData[targetModuleId].input[property];
      EventBus.$emit('set-endpoint-mode', {endpoint: info.sourceId, mode: 'active'});
      EventBus.$emit('set-endpoint-mode', {endpoint: info.targetId, mode: 'active'});
    },
    deleteConnection(info) {
      var sourceModuleId = info.sourceId.replace('-output', '');
      var targetModuleId = info.targetId.substr(0, info.targetId.indexOf('-'));
      var property = info.targetId.split('-')[1];
      if(this.moduleData[targetModuleId].type !== 'data')
        this.moduleData[sourceModuleId].output.data = this.clone(this.moduleData[targetModuleId].input[property]);
      else
        this.moduleData[sourceModuleId].output.data = this.clone(this.moduleData[targetModuleId].output.data);
      var updateObj = {property: property, value: []}; // TODO: this may be problematic, not always a list to reset
      EventBus.$emit('update-module-'+targetModuleId, updateObj);
      jsPlumb.deleteConnection(info);
      EventBus.$emit('set-endpoint-mode', {endpoint: info.sourceId});
      EventBus.$emit('set-endpoint-mode', {endpoint: info.targetId});
    },
    editDescription() {
      this.showModals['edit-description'] = false;
      //this.moduleData[this.editingModuleDescription.id].description = this.editingModuleDescription.description;
    },
    getFormattedTime() {
      var today = new Date();
      var y = today.getFullYear();
      // JavaScript months are 0-based.
      var m = today.getMonth() + 1;
      var d = today.getDate();
      var h = today.getHours();
      var mi = today.getMinutes();
      var s = today.getSeconds();
      return d + "-" + m + "-" + y + "-" + h + "-" + mi + "-" + s;
    },
    importWorkflow(workflow) {
      this.deleteAllModules();
      if(workflow.allModules && workflow.connections && workflow.moduleData) {
        // generate modules
        for(var mod of workflow.allModules) {
          this.generateModule(workflow.moduleData[mod].type, this.clone(workflow.moduleData[mod]), mod);
          var xLim = this.$refs.modules.offsetWidth;
          var yLim = this.$refs.modules.offsetHeight;
          var x = workflow.moduleData[mod].position[0]*xLim;
          var y = workflow.moduleData[mod].position[1]*yLim;
          var w = document.getElementById(mod).offsetWidth;
          var h = document.getElementById(mod).offSetHeight;
          x = x + w > xLim ? xLim - w : x;
          y = y + h > yLim ? yLim - h : y;
          this.moveModule(mod, x, y);
        }
        // update modal input data
        for(var mod of this.allModules) {
          var modData = workflow.moduleData[mod];
          for(var prop in modData.input) {
            if(modData.input[prop]!==null && !workflow.connections.map(c => c.target).includes(mod+'-'+prop)) {
              var updateObj = {property: prop, value: modData.input[prop]};
              EventBus.$emit('update-module-'+mod, updateObj);
            }
          }
        }
        // generate connections
        for(var conn of workflow.connections)
          jsPlumb.connect({source: conn.source, target: conn.target});
        EventBus.$emit('send-notification', {text: 'Project loaded successfully', color: 'success'});
      } else
        EventBus.$emit('send-notification', {text: 'Error importing workflow file'});
    },
    buildWorkflowJson() {
      var newDate = new Date();
      for(var mod of this.allModules) {
        var position = this.getModulePosition(mod);
        var x = parseInt(position[0].slice(0, -2))/this.$refs.modules.offsetWidth;
        var y = parseInt(position[1].slice(0, -2))/this.$refs.modules.offsetHeight;
        this.moduleData[mod].position = [x, y];
      }
      var allConnections = jsPlumb.getAllConnections();
      var connections = [];
      for(var conn of allConnections)
        connections.push({source: conn.sourceId, target: conn.targetId});
      var data = {};
      data.date = newDate;
      data.title = 'Date: ' + newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate() + ' time: ' + newDate.getHours() + ':' + newDate.getMinutes() + ':' + newDate.getSeconds();
      data.allModules = this.allModules;
      data.moduleData = this.moduleData;
      data.connections = connections;
      return data;
    },
    exportWorkflow() {
      var fname = 'decspace-' + this.$store.state.currentProjectName.replace(' ', '-') + '-' + this.getFormattedTime() + '.zip';
      var zip = new JSZip();
      var data = this.buildWorkflowJson();
      const exportData = JSON.stringify(data);
      zip.file('decspace.json', exportData);
      var folder = zip.folder('data');
      for(var mod of this.allModules) {
        var modData = this.moduleData[mod];
        if(modData.type==='data') {
          var csv = Papa.unparse(modData.output, {delimiter: ";"});
          var name = modData.name.endsWith('.csv') ? modData.name : modData.name + '.csv';
          folder.file(name, csv);
        }
      }
      zip.generateAsync({type:"blob"}).then(function(content) {
        saveAs(content, fname);
        EventBus.$emit('send-notification', {text: 'Project exported successfully', color: 'success'});
      });
    },
    saveWorkflow() {
      var data = this.buildWorkflowJson();
      this.versionArray.push(data);
      const exportData = JSON.stringify(data);
      var ownerEmail = this.$store.state.email;
      var projectId = this.$store.state.currentProjectId;
      this.$http.put(this.$store.state.serverHttpUrl+'/project', 
        {_id: projectId, ownerEmail: ownerEmail, saveVersion: exportData}).then(
          function (response) {
            EventBus.$emit('send-notification', {text: 'Project saved successfully', color: 'success'});
          }, function (err) {
            EventBus.$emit('send-notification', {text: 'Error saving project'});
      });
    },
  },
  mounted () {
    // connector library initialization
    jsPlumb.ready(() => {
      jsPlumb.importDefaults({
        Connector: ["Straight"],
        ConnectionOverlays: [["Arrow", {width:10, length:10}]],
			  DragOptions: { zIndex: 2000 },
			  Container: "modules",
			  Anchor: ["Center"],
        Endpoint: ["Blank", {width: 1, height: 1}],
        PaintStyle: {stroke: "#4BB543", strokeWidth: 3},
        HoverPaintStyle: {strokeWidth: 5},
        MaxConnections: 1
      });
      this.initializeWorkspace();
    });
    // connection click event handler
    jsPlumb.bind("dblclick", this.deleteConnection);
    jsPlumb.bind("connection", this.newConnection);
    // event bus callback functions (events sent from the modules and modals)
    EventBus.$on('duplicate-module', mod => { // user clicked the module duplicate button
      this.duplicateModule(mod);
    });
    EventBus.$on('edit-module-name', mod => { // user edited the module name
      this.moduleData[mod.id].name = mod.name;
    });
    EventBus.$on('edit-module-description', mod => { // user edited the module description
      this.editingModuleDescription = this.moduleData[mod];
      this.showModals['edit-description'] = true;
    });
    EventBus.$on('destroy-module', mod => { // user clicked the module close button
      this.$swal({
        titleText: 'Delete module ' + this.moduleData[mod].name + ' and its connections?',
        type: 'warning',
        showCancelButton: true,
        allowEnterKey: false,
        confirmButtonColor: '#FF5252',
        cancelButtonColor: '#33b5e5',
        confirmButtonText: 'Delete',
        customClass: 'elevation-5'
      }).then((result) => {
        if(result.value)
          this.deleteModule(mod);
      });
    });
    EventBus.$on('save-module-data', moduleAttributes => { // user closed method modal, modal updates user entered data
      var id = moduleAttributes.id;
      for(var prop of Object.keys(moduleAttributes)) {
        this.moduleData[id][prop] = moduleAttributes[prop];}
    });
    EventBus.$on('generate-data-module', obj => { // method module parameter is dirty -> generate data module
      var headers = Object.keys(obj.value[0]);
      var index = headers.indexOf('watcher');
      if(index > -1) headers.splice(index, 1);
      var modData = {
        name: obj.property,
        type: 'data',
        output: {
          data: obj.value,
          headers: headers
        }
      };
      var dataModId = this.generateModule('data', modData);
      var targetPos = this.getModulePosition(obj.target);
      var x = parseInt(targetPos[0].slice(0, -2))-180;
      var y = parseInt(targetPos[1].slice(0, -2))+17*obj.yOffset;
      x = x < 0 ? 0 : x;
      this.moveModule(dataModId, x, y);
      jsPlumb.connect({source: dataModId+'-output', target: obj.target+'-'+obj.property});
    });
    EventBus.$on('add-endpoints', endpoints => { // module lets workspace know what its available endpoints are
      if(this.moduleData[endpoints.id])
        this.moduleData[endpoints.id].endpoints = endpoints.endpoints;
    });
    EventBus.$on('check-connection', id => { // data modal checking if should show itself, or if it is connected and should show target module
      var connections = jsPlumb.getConnections();
      var found = connections.find(function(conn) {return conn.sourceId === id+'-output';});
      if(found) {
        var targetId = found.targetId.substr(0, found.targetId.indexOf('-'));
        var property = found.targetId.split('-')[1];
        EventBus.$emit('show-modal-'+targetId, property);
      } else
        EventBus.$emit('show-modal-data-'+id);
    });
    EventBus.$on('set-endpoint-mode', obj => { // sets module endpoint to either active, warning, error or none
      document.getElementById(obj.endpoint).classList.remove("module-endpoint-active");
      document.getElementById(obj.endpoint).classList.remove("module-endpoint-warning");
      document.getElementById(obj.endpoint).classList.remove("module-endpoint-error");
      if(obj.mode)
        document.getElementById(obj.endpoint).classList.add("module-endpoint-"+obj.mode);
    });
  },
  beforeDestroy() {
    jsPlumb.reset();
    this.deleteAllModules();
    EventBus.$off('duplicate-module');
    EventBus.$off('edit-module-name');
    EventBus.$off('edit-module-description');
    EventBus.$off('destroy-module');
    EventBus.$off('save-module-data');
    EventBus.$off('generate-data-module');
    EventBus.$off('add-endpoints');
    EventBus.$off('check-connection');
    EventBus.$off('set-endpoint-mode');
  }
}

</script>

<style scoped>
  #modules {
    position: relative;
    height: 65vh;
    border: black 1px solid;
  }

  #header {
    margin: 5px;
    font-size: 30px;
    line-height: 1.5;
  }

</style>


// WEBPACK FOOTER //
// src/components/Workspace/Workspace.vue